import script from "./DictView.vue?vue&type=script&setup=true&lang=js"
export * from "./DictView.vue?vue&type=script&setup=true&lang=js"

import "./DictView.vue?vue&type=style&index=0&id=10e364e6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10e364e6"]])

export default __exports__